import { Component } from '@angular/core';
import {SharedModule} from "primeng/api";
import {ToastModule} from "primeng/toast";

@Component({
  selector: 'app-toast',
  standalone: true,
    imports: [
        SharedModule,
        ToastModule
    ],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {

}
